"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Page = _interopRequireDefault(require("../01_atoms/Page"));

var _TopBar = _interopRequireDefault(require("../01_atoms/TopBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DefaultScreen = function DefaultScreen(_ref) {
  var title = _ref.title,
      onBack = _ref.onBack,
      children = _ref.children,
      _ref$topBarChildren = _ref.topBarChildren,
      topBarChildren = _ref$topBarChildren === void 0 ? null : _ref$topBarChildren,
      _ref$topBarRightChild = _ref.topBarRightChildren,
      topBarRightChildren = _ref$topBarRightChild === void 0 ? null : _ref$topBarRightChild;
  return /*#__PURE__*/_react["default"].createElement(_Page["default"], null, /*#__PURE__*/_react["default"].createElement(_TopBar["default"], {
    title: title,
    leftIcon: onBack ? 'arrow left' : null,
    onLeftIconClick: onBack,
    rightChildren: topBarRightChildren
  }, topBarChildren), children);
};

var _default = DefaultScreen;
exports["default"] = _default;